import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  SystemAdminSpecificLeave
} from "../../Repository/Api";
import { imagepath } from "../../Repository/BaseUrl";
import { NumberOfDays } from "../Common/FinancialYear";
import { errorMsg } from "../Toastify";
const SystemadminEmployeeleavespecific = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [SpecificProfile, setSecificProfile] = useState({});

  useEffect(() => {
    getSpecificlist();
  },[]);

  const getSpecificlist = async () => {
    const response = await SystemAdminSpecificLeave(id, token);
    if (response && response.statusCode === 200) {
      setSecificProfile(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Leave Details
                </h6>
                <div className="row">
                  <div className="col-lg-3">
                    <label className="labeltext"> Nature of Leave </label>
                    <input
                      type="text"
                      className="fieldinput"
                      defaultValue={SpecificProfile?.nature_of_leave}
                      disabled
                    />
                  </div>
                  {SpecificProfile?.duration_type === "half_day" ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext"> Duration Type</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.duration_type}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext"> Half Day Type</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.half_day_leave_type}
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.commuted_type ? (
                    <div className="col-lg-3">
                      <label className="labeltext"> Commuted Type</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={
                          SpecificProfile?.commuted_type !== undefined
                            ? SpecificProfile.commuted_type
                              .toString()
                              .replace(/half_pay/g, "Half Pay")
                              .replace(/full_pay/g, "Full Pay")
                            : ""
                        }
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.nature_of_leave ===
                    "Special Casual Leave (SCL)" ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext">
                          Title of the Program
                        </label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.title_of_the_program}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Topic</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.topic}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Organized By</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.organized_by}
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.nature_of_leave ===
                    "Child Care Leave (CCL)" ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext">Child Name</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={SpecificProfile?.children_detail?.name}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Child DOB</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={moment(
                            SpecificProfile?.children_detail?.dob
                          ).format("DD-MM-yyyy")}
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-3">
                    <label className="labeltext"> No. of Days</label>
                    <input
                      type="text"
                      className="fieldinput"
                      defaultValue={SpecificProfile?.no_of_days}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Leave Start Date</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={moment(SpecificProfile?.start_date).format(
                        "DD-MM-yyyy"
                      )}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Leave End Date</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={moment(SpecificProfile?.end_date).format(
                        "DD-MM-yyyy"
                      )}
                      disabled
                    />
                  </div>
                  {SpecificProfile?.prefix ? (
                    <div className="col-lg-3">
                      <label className="labeltext"> Prefix</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={moment(SpecificProfile?.prefix).format(
                          "DD-MM-yyyy"
                        )}
                        disabled
                      />
                      <br />
                      <small>
                        No of prefix Holidays :
                        <span className="fw-bold ms-2">
                          {NumberOfDays(SpecificProfile?.prefix, SpecificProfile?.start_date)}
                        </span>
                      </small>
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.suffix ? (
                    <div className="col-lg-3">
                      <label className="labeltext"> Suffix</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={moment(SpecificProfile?.suffix).format(
                          "DD-MM-yyyy"
                        )}
                        disabled
                      />
                      <br />
                      <small>
                        No of suffix Holidays :
                        <span className="fw-bold ms-2">
                          {SpecificProfile?.no_of_days !== 1 ?
                            NumberOfDays(SpecificProfile?.end_date, SpecificProfile?.suffix) :
                            NumberOfDays(SpecificProfile?.start_date, SpecificProfile?.suffix)
                          }
                        </span>
                      </small>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-3">
                    <label className="labeltext">Alternate</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={
                        SpecificProfile?.alternate === "no_class"
                          ? SpecificProfile?.alternate?.replace(/_/g, " ")
                          : SpecificProfile?.alternate
                      }
                      disabled
                    />
                  </div>
                  {SpecificProfile?.alternate === "arranged" ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Alternate Person</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.alternate_person_name}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-3">
                    <label className="labeltext">Leaving Headquarters</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={
                        SpecificProfile?.leaving_head_quaters !== undefined
                          ? SpecificProfile.leaving_head_quaters
                            .toString()
                            .replace(/true/g, "Yes")
                            .replace(/false/g, "No")
                          : ""
                      }
                      disabled
                    />
                  </div>
                  {SpecificProfile?.leaving_head_quaters === true ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Location</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.location_during_leave_period}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.reference_attachment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">
                        Ref... (Attach Document)
                      </label>
                      <div className="fieldinputfile">
                        <span
                          className="namelink"
                          onClick={() => {
                            window.open(`${imagepath}${SpecificProfile?.reference_attachment}`);
                          }}
                          target="_blank"
                        >
                          View Document
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-3">
                    <label className="labeltext">Reason</label>
                    <textarea
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.reason}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Address - Leave Period</label>
                    <textarea
                      type="text"
                      className="fieldinput"
                      value={SpecificProfile?.address}
                      disabled
                    />
                  </div>
                  {SpecificProfile?.hod_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Hod Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.hod_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.admin_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Admin Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.admin_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.director_comment ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Director Comment</label>
                      <textarea
                        type="text"
                        className="fieldinput"
                        value={SpecificProfile?.director_comment}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {SpecificProfile?.joining_report_details?.joining_date ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext">Rejoin Date</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(
                            SpecificProfile?.joining_report_details
                              ?.joining_date
                          ).format("DD-MM-yyyy")}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Rejoin Time</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={
                            SpecificProfile?.joining_report_details
                              ?.joining_time
                          }
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {SpecificProfile?.joining_report_details
                    ?.medical_certificate ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Medical Certificate</label>
                      <div className="fieldinputfile">
                        <span
                          className="namelink"
                          onClick={() => {
                            window.open(
                              `${imagepath}${SpecificProfile?.joining_report_details
                                ?.medical_certificate[0]}`
                            );
                          }}
                          target="_blank"
                        >
                          View Document
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SystemadminEmployeeleavespecific;
